// src/routes/PrivateRoute.jsx

import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import useAuthStore from '../stores/useAuthStore';

const PrivateRoute = () => {
  const authBootstrapStatus = useAuthStore((s) => s.authBootstrapStatus);
  const sessionExpired = useAuthStore((s) => s.sessionExpired);

  if (sessionExpired) return null;

  if (authBootstrapStatus === 'idle' || authBootstrapStatus === 'bootstrapping') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (authBootstrapStatus === 'policy_pending') {
    return <Navigate to="/terms-and-conditions" replace />;
  }

  if (authBootstrapStatus === 'authenticated') {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
};

export default PrivateRoute;